import { tns } from 'tiny-slider';

document.addEventListener(
	'DOMContentLoaded',
	function () {
		let slider = []; //[{ id: 0, slide: [] }]
		const slides = document.querySelectorAll('.carousel');

		const construct = (slide, index) => {
			const wrapper = slide.querySelector('.carousel-content');
			const id = slide.getAttribute('data-id');
			const navigation = slide.getAttribute('data-navigation') === 'true' ? true : false;
			const navigationDesktop = slide.getAttribute('data-navigationDesk') === 'true' ? true : false;
			const dots = slide.getAttribute('data-dots') === 'true' ? true : false;
			const centered = slide.getAttribute('data-centered') === 'true' ? true : false;
			const centeredDesktop = slide.getAttribute('data-centeredDesktop') === 'true' ? true : false;
			const isLoop = slide.getAttribute('data-loop') === 'true' ? true : false;
			const autoWidth = slide.getAttribute('data-autoWidth') === 'true' ? true : false;
			const autoWidthDesktop = slide.getAttribute('data-autoWidthDesktop') === 'true' ? true : false;
			const isAutoplay = slide.getAttribute('data-autoplay') === 'true' ? true : false;
			const speed = parseInt(slide.getAttribute('data-speed'));
			const autoplayTimeout = parseInt(slide.getAttribute('data-autoplayTimeout'));
			const gutter = parseInt(slide.getAttribute('data-gutter')) || 0;
			const gutterDesktop = parseInt(slide.getAttribute('data-gutterDesktop')) || 0;
			const perView = parseInt(slide.getAttribute('data-perView'));
			const perView768 = parseInt(slide.getAttribute('data-perView768'));
			const perView960 = parseInt(slide.getAttribute('data-perView960'));
			const perView1024 = parseInt(slide.getAttribute('data-perView1024'));
			const navPosition = slide.getAttribute('data-navPosition') === 'bottom' ? 'bottom' : 'top';
			const controlsPosition = slide.getAttribute('data-controlsPosition') === 'bottom' ? 'bottom' : 'top';
			const fixedWidth =
				slide.getAttribute('data-fixedWidth') !== false && slide.getAttribute('data-fixedWidth') !== '0'
					? parseInt(slide.getAttribute('data-fixedWidth'))
					: false;
			const fixedWidthTablet =
				slide.getAttribute('data-fixedWidthTablet') !== false && slide.getAttribute('data-fixedWidthTablet') !== '0'
					? parseInt(slide.getAttribute('data-fixedWidthTablet'))
					: false;
			const fixedWidthDesktop =
				slide.getAttribute('data-fixedWidthDesktop') !== false && slide.getAttribute('data-fixedWidthDesktop') !== '0'
					? parseInt(slide.getAttribute('data-fixedWidthDesktop'))
					: false;

			const sliderConfigs = {
				container: wrapper,
				nav: dots,
				navPosition: navPosition,
				controlsPosition: controlsPosition,
				loop: isLoop,
				autoplay: isAutoplay,
				autoWidth: autoWidth,
				slideBy: 'page',
				autoplayTimeout: autoplayTimeout,
				speed: speed,
				preventScrollOnTouch: 'auto',
				responsive: {
					0: {
						...(!autoWidth && { items: perView, fixedWidth: fixedWidth }),
						controls: navigation,
						gutter: gutter,
						center: centered,
					},
					768: {
						...(!autoWidth && { items: perView768, fixedWidth: fixedWidthTablet }),
						controls: navigation,
						center: centeredDesktop,
					},
					960: {
						...(!autoWidth && { items: perView960, fixedWidth: fixedWidthDesktop }),
						controls: navigationDesktop,
						gutter: gutterDesktop,
					},
					1200: {
						...(!autoWidth && { items: perView1024 }),
						controls: navigationDesktop,
					},
				},
			};

			const allItems = Array.from(wrapper.children);

			allItems.forEach((elm, index) => {
				elm.setAttribute('data-index', index);
			});

			if (slider[index] === null) {
				slider.push({ id: id ? id : index, slide: tns(sliderConfigs) });
			} else {
				slider[index] = {
					id: id ? id : index,
					slide: tns(sliderConfigs),
				};
			}

			wrapper.closest('.carousel').setAttribute('current-slide', 1);

			const customizedFunction = (info) => {
				wrapper.closest('.carousel').setAttribute('current-slide', info.displayIndex);
			};

			slider[index]?.slide?.events.on('transitionStart', customizedFunction);
		};

		slides.forEach(async (slideItem, index) => {
			construct(slideItem, index);
		});

		//Make the sliders accessible in another document.
		window.sliderList = slider;

		document.dispatchEvent(new CustomEvent('CarouselReady'));
	},
	false,
);
